export default __webpack_public_path__ + "static/data-vis-color-role-dont-8126a8f0145ec81fd59abe58c3caa59a.png";